import React, { useEffect, useState } from 'react';
import {
	Button,
	Modal,
	Select,
	SelectOption,
	Alerts,
	Checkbox,
	Toast,
} from '@kaleyra/emmy';
import { debounce, isEmpty } from 'lodash';
import { useTranslation } from 'react-i18next';
import LoaderGif from '../../../../../assets/loader.gif';
import Styles from './CallbackProfileModal.module.scss';

export type MapStateType = {
	modalVisibility: boolean;
	callbackProfileList: any;
	updateCallbackProfileLoading: boolean;
	params: any;
	wabaID: any;
	isScollOptionsLoading: boolean;
};

export type DispatchPropsType = {
	onLoadCallbackProfile: () => void;
	onPaginateCallbackProfiles: () => void;
	onSearchTextChange: (searchText: string) => void;
	getConfiguredCallbackProfile: (wabaId:string) => void;
	addCallbackProfile: (wabaId:string, data:any, callBack:any) => void;
	updateCallbackProfile: (wabaId:string, data:any, callBack:any) => void;
	onCloseModal: () => void;
	applyFilters: (filters: any) => void;
};

export const CallbackProfileModal: React.FC<
	MapStateType & DispatchPropsType
> = ({
	modalVisibility,
	isScollOptionsLoading,
	callbackProfileList,
	updateCallbackProfileLoading,
	params,
	wabaID,
	onCloseModal,
	applyFilters,
	getConfiguredCallbackProfile,
	addCallbackProfile,
	updateCallbackProfile,
	onPaginateCallbackProfiles,
	onSearchTextChange,
	onLoadCallbackProfile,
}) => {
	const { t } = useTranslation();
	const { mode, callback } = params;
	const [selectCallback, setSelectCallback] = useState<
		string | number | undefined
	>();
	const [isChannelFilter, setIsChannelFilter] = useState<boolean>(false);
	const [applyForAllWaba, setApplyForAllWaba] = useState<boolean>(false);
	const [waba,setWaba] = useState<any>();

	useEffect(() => {
		onLoadCallbackProfile();
	}, []);

	useEffect(()=>{
		if (!isEmpty(wabaID.wabaIdObject)) {
			setWaba(
				wabaID.wabaIdObject.data.filter(
					(waba: any) => wabaID.wabaId === waba.waba_id
				)
			);
		}
	},[wabaID?.wabaId]);

	useEffect(() => {
		if(callback) {
			setSelectCallback(callback?.callback_profile_id);
		}
	},[callback]);

	const onScroll = (e: any, val?: string) => {
		const { target } = e;
		if (target.scrollTop + target.offsetHeight === target.scrollHeight) {
			onPaginateCallbackProfiles();
		}
	};

	const debounceChange = debounce((val: string = '') => {
		onSearchTextChange(val);
	}, 400);

	const renderBody = () => {
		return (
			<div
				className={Styles.callbackProfileModal}
			>
				{mode === 'update' && (
					<div className={Styles.alertsBanner}>
						<Alerts
							content={t('webhookUpdateWarning')}
							type="warning"
						/>
					</div>
				)}
				<div  className={Styles.alertsBanner}>
					<Alerts
						content={t('cbProfileApplyAllWebhook', {
							waba_ID: waba? waba[0].business_name:wabaID?.wabaId,
						})}
						type="draft"
					/>
				</div>
				<Select
					showSearch={true}
					onSearch={(value: string) => {
						if (value.length > 2 || value === '') {
							debounceChange(value);
						}
					}}
					value={selectCallback}
					placeholder={t('KLR07063')}
					label={t('KLR07063')}
					onPopupScroll={onScroll}
					filterOption={(input, option: any) => {
						return option['data-filter']
							? option
							: option['data-label']
									.toLowerCase()
									.includes(input.toLowerCase());
					}}
					notFoundContent={
						isScollOptionsLoading ? (
							<div>
								<div>
									<img src={LoaderGif} alt="loader" />
								</div>
								<div>{t('KLR09057')}</div>
							</div>
						) : null
					}
					onChange={(e) => {
						if(e.toString() == callback?.callback_profile_id){
							setApplyForAllWaba(false);
						}
						setSelectCallback(e.toString())
						}
					}
				>
					<SelectOption
						value={'filter'}
						disabled
						data-filter={'filter'}
					>
						<>
							<Checkbox
								label={t('whatsappChannelFilter')}
								checked={isChannelFilter}
								onChange={(e) => {
									applyFilters({
										channel: e.target.checked ? "whatsapp" : null,
									});
									setIsChannelFilter(e.target.checked);
								}}
							/>
						</>
					</SelectOption>
					{!isEmpty(callbackProfileList) &&
						callbackProfileList.map((ele: any, index: any) => {
							return (
								<SelectOption
									key={index}
									value={ele.profile_id}
									data-label={ele.title}
								>
									<>
										<div>{ele.title}</div>
										<div
											style={{
												fontSize: '12px',
												color: '#8D9DB0',
												lineHeight: '16px',
											}}
										>
											{ele.http_method} . {ele.profile_id}
										</div>
									</>
								</SelectOption>
							);
						})}
				</Select>
				<div className={Styles.applyForAllCheckBoxContainer}>
					<Checkbox
						checked={applyForAllWaba}
						disabled={callback?.all_waba && callback?.callback_profile_id == selectCallback}
						onChange={(e) => {
							setApplyForAllWaba(e.target.checked);
						}}
					/>
					<p>{t('cbProfileApplyAllWebhookCheckbox')}</p>
				</div>
			</div>
		);
	};

	const onClickCancel = () => {
		setSelectCallback(mode === 'update'? callback?.callback_profile_id :undefined);
		setIsChannelFilter(false);
		setApplyForAllWaba(false);
		onCloseModal();
	};

	const handlecallback = (res: any, success: boolean) => {
		if(success){
			getConfiguredCallbackProfile(wabaID.wabaId);
			Toast(
				applyForAllWaba
					? t('successCallBackProfileUpdateForAllWaba')
					: t('successCallBackProfileUpdateForWaba'),
				'success'
			);
			onCloseModal();
		}else{
			Toast(t('errorUpdatingCallbackProfile'),"error");
		}
	}

	const onSave = () => {
		const data = {
			callback_profile_id: selectCallback,
			all_waba: applyForAllWaba ? 1: 0
		}
		if(mode === 'update'){
			updateCallbackProfile(wabaID.wabaId,data,handlecallback);
		}
		else{
			addCallbackProfile(wabaID.wabaId,data,handlecallback);
		}
	}

	const renderFooter = () => {
		return (
			<>
				<Button
					type="tertiary"
					onClick={onClickCancel}
					style={{ marginRight: '16px' }}
				>
					{t('mainCancel')}
				</Button>
				<Button onClick={onSave} disabled={updateCallbackProfileLoading}>{mode === 'create'? t('mainSave'): t('flwUpdate')}</Button>
			</>
		);
	};
	return (
		<Modal
			visible={modalVisibility}
			title={mode === 'create' ? t('KLR03031') : t('KLR07064')}
			body={renderBody()}
			footer={renderFooter()}
			width='440px'
		/>
	);
};

export default CallbackProfileModal;
